export const homeConfig = {
    tabLabelProjects: "Projects",
    tabLabelPromptLibrary: "Prompt Library",
    refreshMessage: "Refreshing List...",
    privacyNoticeLabel: "Privacy Notice",
    engagementManagementLabel: "Engagement Management Guidance",
    btnRefreshLabel: "Refresh",
    refreshSuccessToastMsg: "Refresh Complete",
    refreshFailureToastMsg: "List could not be refreshed",
    paansMessage: "Privacy Notice acknowledgement pending"
};